/* Zabi PDP — productfoto-lightbox.
   Klik op de hoofdfoto opent een fullscreen overlay met: vorige/volgende
   (pijlen + swipe), klik/tap om in te zoomen + pannen, sluiten (X/Esc/backdrop).
   Dependency-vrij; werkt op de standaard- en restyle-PDP's (custom galerij). */
(function () {
  var overlay = null;
  var imgEl = null;
  var stageEl = null;
  var curEl = null;
  var totalEl = null;
  var slides = [];
  var index = 0;
  var zoomed = false;
  var onGoto = null;

  function build() {
    if (overlay) return;
    overlay = document.createElement('div');
    overlay.className = 'zabi-lightbox';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.hidden = true;
    overlay.innerHTML =
      '<button type="button" class="zabi-lightbox__close" aria-label="Sluiten">' +
        '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
      '</button>' +
      '<button type="button" class="zabi-lightbox__nav zabi-lightbox__nav--prev" aria-label="Vorige foto">' +
        '<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>' +
      '</button>' +
      '<button type="button" class="zabi-lightbox__nav zabi-lightbox__nav--next" aria-label="Volgende foto">' +
        '<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>' +
      '</button>' +
      '<div class="zabi-lightbox__stage" data-lb-stage>' +
        '<img class="zabi-lightbox__img" data-lb-img alt="">' +
      '</div>' +
      '<div class="zabi-lightbox__counter"><span data-lb-cur>1</span> / <span data-lb-total>1</span></div>';
    document.body.appendChild(overlay);

    imgEl = overlay.querySelector('[data-lb-img]');
    stageEl = overlay.querySelector('[data-lb-stage]');
    curEl = overlay.querySelector('[data-lb-cur]');
    totalEl = overlay.querySelector('[data-lb-total]');

    overlay.querySelector('.zabi-lightbox__close').addEventListener('click', close);
    overlay.querySelector('.zabi-lightbox__nav--prev').addEventListener('click', function (e) { e.stopPropagation(); go(-1); });
    overlay.querySelector('.zabi-lightbox__nav--next').addEventListener('click', function (e) { e.stopPropagation(); go(1); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });

    imgEl.addEventListener('click', function (e) { e.stopPropagation(); toggleZoom(e); });
    imgEl.addEventListener('mousemove', panIfZoomed);

    // Swipe + pan (touch)
    var startX = 0, startY = 0, moved = false;
    stageEl.addEventListener('touchstart', function (e) {
      var t = e.touches[0];
      startX = t.clientX; startY = t.clientY; moved = false;
    }, { passive: true });
    stageEl.addEventListener('touchmove', function (e) {
      var t = e.touches[0];
      if (zoomed) { panTo(t.clientX, t.clientY); e.preventDefault(); return; }
      if (Math.abs(t.clientX - startX) > 8) moved = true;
    }, { passive: false });
    stageEl.addEventListener('touchend', function (e) {
      if (zoomed) return;
      var dx = (e.changedTouches[0].clientX) - startX;
      var dy = (e.changedTouches[0].clientY) - startY;
      if (moved && Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
        go(dx < 0 ? 1 : -1);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (overlay.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') go(-1);
      else if (e.key === 'ArrowRight') go(1);
    });
  }

  function setZoom(on) {
    zoomed = on;
    imgEl.classList.toggle('is-zoomed', on);
    if (!on) imgEl.style.transformOrigin = 'center center';
  }

  function toggleZoom(e) {
    if (!zoomed) { setZoom(true); panTo(e.clientX, e.clientY); }
    else setZoom(false);
  }

  function panIfZoomed(e) { if (zoomed) panTo(e.clientX, e.clientY); }

  function panTo(clientX, clientY) {
    var r = imgEl.getBoundingClientRect();
    var px = Math.min(100, Math.max(0, ((clientX - r.left) / r.width) * 100));
    var py = Math.min(100, Math.max(0, ((clientY - r.top) / r.height) * 100));
    imgEl.style.transformOrigin = px + '% ' + py + '%';
  }

  function render() {
    setZoom(false);
    var s = slides[index];
    imgEl.src = s.full;
    imgEl.alt = s.alt || '';
    curEl.textContent = String(index + 1);
    totalEl.textContent = String(slides.length);
    var multi = slides.length > 1;
    overlay.querySelector('.zabi-lightbox__nav--prev').style.display = multi ? '' : 'none';
    overlay.querySelector('.zabi-lightbox__nav--next').style.display = multi ? '' : 'none';
    overlay.querySelector('.zabi-lightbox__counter').style.display = multi ? '' : 'none';
    if (typeof onGoto === 'function') onGoto(index);
  }

  function go(dir) {
    if (slides.length < 2) return;
    index = (index + dir + slides.length) % slides.length;
    render();
  }

  function open(list, start, gotoCb) {
    build();
    slides = list;
    index = start || 0;
    onGoto = gotoCb || null;
    render();
    overlay.hidden = false;
    document.documentElement.classList.add('zabi-lightbox-open');
  }

  function close() {
    if (!overlay) return;
    setZoom(false);
    overlay.hidden = true;
    document.documentElement.classList.remove('zabi-lightbox-open');
  }

  function initGallery(gallery) {
    var mains = Array.prototype.slice.call(gallery.querySelectorAll('[data-zabi-main]'));
    if (!mains.length) return;

    function buildList() {
      return mains.map(function (m) {
        return { full: m.getAttribute('data-zoom-src') || m.currentSrc || m.src, alt: m.alt };
      });
    }

    // Sync gallery active state when navigating in the lightbox.
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-zabi-thumb]'));
    function syncGallery(i) {
      mains.forEach(function (m, idx) { m.classList.toggle('is-active', idx === i); });
      thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === i); });
    }

    mains.forEach(function (m, i) {
      m.classList.add('zabi-pdp-gallery__image--zoomable');
      m.addEventListener('click', function () {
        // Start op de nu-actieve foto (val terug op de aangeklikte).
        var startIdx = mains.findIndex(function (x) { return x.classList.contains('is-active'); });
        if (startIdx < 0) startIdx = i;
        open(buildList(), startIdx, syncGallery);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-zabi-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Theme-editor herlaad van de sectie.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector) {
      e.target.querySelectorAll('[data-zabi-gallery]').forEach(initGallery);
    }
  });
})();
